// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vksu","newExpiryDate":"styles_newExpiryDate__3BuPF","footer":"styles_footer__i1ZNM"};